import { render } from "./AdminAlerts.vue?vue&type=template&id=510512cc&scoped=true"
import script from "./AdminAlerts.vue?vue&type=script&lang=js"
export * from "./AdminAlerts.vue?vue&type=script&lang=js"

import "./AdminAlerts.vue?vue&type=style&index=0&id=510512cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510512cc"]])

export default __exports__